import { Card, Col, Row, Skeleton, Typography } from "antd";
import { SanitizeHTML, CompanyLogo } from "@bindeleddet/core/components";
import { Company } from "@bindeleddet/core/types";
import { useViewport } from "@bindeleddet/core/hooks";
import React from "react";
import { useHistory } from "react-router-dom";
import FollowCompanyButton from "components/FollowCompanyButton/FollowCompanyButton";
import { StyledHr, StyledTitle } from "./style";

const { Text } = Typography;

interface Props {
  company: Company;
}

const AboutCompany: React.FC<Props> = ({ company }) => {
  const { width } = useViewport();
  const breakpoint = 768;
  const history = useHistory();

  return (
    <>
      <Card
        bodyStyle={{ padding: "2em", cursor: "pointer", width: "100%" }}
        onClick={() => history.push(`/companies/${company.id}`)}
      >
        <Row>
          <StyledTitle level={3}>Om {company?.name}</StyledTitle>
        </Row>
        <Row justify="start">
          <StyledHr />
        </Row>

        <Row gutter={[16, 16]}>
          <Col lg={4} md={6} sm={24} xs={24}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 12,
                width: "100%",
                maxWidth: width < breakpoint ? 180 : 200,
                margin: "0 auto",
              }}
            >
              {company ? (
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 10,
                    border: "1px solid #e0e0e0",
                    padding: "10%",
                  }}
                >
                  <CompanyLogo size="100%" companyId={company.id} src={company.logo} />
                </div>
              ) : (
                <Skeleton.Image style={{ width: "100%", height: "auto" }} />
              )}
              <div
                style={{ width: "100%" }}
                onClick={e => e.stopPropagation()}
                role="presentation"
                onKeyDown={e => e.stopPropagation()}
                tabIndex={-1}
              >
                <FollowCompanyButton companyId={company.id} companyName={company.name} block size="small" />
              </div>
            </div>
          </Col>
          <Col lg={20} md={18} sm={24} xs={24}>
            {company ? (
              <Text>
                <SanitizeHTML html={company?.description ?? ""} />
              </Text>
            ) : (
              <Skeleton active />
            )}
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default AboutCompany;
